import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

interface SMB {
  id?: string;
  name: string;
}

interface SMBSelectorProps {
  smbs: SMB[];
  selectedSMBId: string;
  onChange: (value: string) => void;
  loading?: boolean;
}

const SMBSelector: React.FC<SMBSelectorProps> = ({
  smbs,
  selectedSMBId,
  onChange,
  loading = false,
}) => {
  if (smbs.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <FormControl fullWidth sx={{ maxWidth: 400 }}>
        <InputLabel id="smb-select-label">Select Business</InputLabel>
        <Select
          labelId="smb-select-label"
          value={selectedSMBId}
          label="Select Business"
          onChange={(e) => onChange(e.target.value)}
          disabled={loading}
        >
          {smbs.map((smb) => (
            <MenuItem key={smb.id} value={smb.id}>
              {smb.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SMBSelector;
